import { t } from '../../i18n.es.js';
import React from 'react';
import { styled } from '@teko/ui';

const Text = styled.a`
  &,
  &:hover,
  &:focus,
  &:visited {
    color: #047fff;
    text-decoration: none;
  }
`;
const TermAndPolicyText = ({
  link = "https://help.phongvu.vn",
  text = t("\u0111i\u1EC1u ki\u1EC7n s\u1EED d\u1EE5ng v\xE0 ch\xEDnh s\xE1ch"),
  className
}) => {
  return /* @__PURE__ */ React.createElement(Text, {
    href: link,
    target: "_blank",
    rel: "noopener noferrer",
    className,
    onClick: (event) => {
      event.stopPropagation();
    }
  }, text);
};

export { TermAndPolicyText };
